<template>
	<v-layout wrap>
		<v-flex xs12 mb-2>
			<v-layout wrap>
				<v-flex xs4>
					<v-layout>
						<v-flex xs6 pa-1 class="content-label">Fecha</v-flex>
						<v-flex xs6 pa-1 class="content-text" v-if="rowSelected.typeRegisterId !== 136">{{ rowSelected.date | exactDate }}</v-flex>
						<date-component
							v-else
							:date="rowSelected.date"
							icon="/static/img/calendar.svg"
							placeholder="Fecha"
							@on-input="setModelData({ model: 'date', value: $event })"
						></date-component>
					</v-layout>
				</v-flex>
				<v-flex xs4>
					<v-layout>
						<v-flex xs6 pa-1 class="content-label">Asiento</v-flex>
						<v-flex xs6 pa-1 class="content-text">
							<span>{{ rowSelected.code }}</span>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs4>
					<v-layout>
						<v-flex xs6 pa-1 class="content-label">Origen</v-flex>
						<v-flex xs6 pa-1 class="content-text">{{ rowSelected.typeRegister.name }}</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
		</v-flex>
		<v-flex xs12 mb-2>
			<v-layout wrap>
				<v-flex xs12>
					<v-layout>
						<v-flex xs3 pa-1 class="content-label">Detalle</v-flex>
						<v-flex xs9 pa-1 class="content-text">
							<span>{{ rowSelected.gloss }}</span>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
		</v-flex>
		<v-flex xs12>
			<v-layout wrap>
				<v-flex xs6>
					<v-layout>
						<v-flex xs6 pa-1 class="content-label">Cta. Contable</v-flex>
						<v-flex xs6 pa-1 class="content-text">{{ Object.keys(rowDetail).length ? rowDetail.accountingAccount.name : null}}</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs6>
					<v-layout>
						<v-flex xs6 pa-1 class="content-label">Referencia</v-flex>
						<v-flex xs6 pa-1 class="content-text">{{ Object.keys(rowDetail).length ? rowDetail.reference : null}}</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>
<script>
import dateComponent from '@/components/autocomplete/date-component';
import { format } from 'date-fns';

function getDate(date) {
	return format(date, 'DD-MM-YYYY');
}

function setModelData({ model, value }) {
	if (model === 'date') {
		this.rowSelected[model] = value;
	}
	this.$emit('change-date', this.rowSelected[model]);
}

export default {
	name: 'journal-detail-table',
	components: {
		dateComponent,
	},
	methods: {
		getDate,
		setModelData,
	},
	props: {
		rowSelected: {
			default: () => {},
			type: Object,
		},
		rowDetail: {
			default: () => {},
			type: Object,
		},
	},
};
</script>
<style lang="scss" scoped>
	.content-label {
		color: #2c404a;
		background-color: #e0e5e8;
		font-family: map-get($fonts, AvenirRegular);
		font-size: 12px;
		font-weight: 500;
	}

	.content-text {
		background-color: white;
		font-family: map-get($fonts, AvenirRegular);
		font-size: 12px;
	}
</style>


// WEBPACK FOOTER //
// src/components/journal/journal-detail-table.vue